export const EXPENSE_CATEGORIES = [
  { id: 'trasporto', label: 'Trasporto' },
  { id: 'cibo', label: 'Cibo' },
  { id: 'alloggio', label: 'Alloggio' },
  { id: 'biglietti', label: 'Biglietti' },
  { id: 'shopping', label: 'Shopping' },
  { id: 'altro', label: 'Altro' },
];

export function categoryLabel(id) {
  return EXPENSE_CATEGORIES.find((c) => c.id === id)?.label ?? id ?? 'Altro';
}
